import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useState } from "react";
import { toast } from "sonner";

interface ReturnDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedProduct: any;
  onConfirm: (quantity: number, refundAmount: number, paymentMethod: string, condition: string) => void;
}

export const ReturnDialog = ({
  open,
  onOpenChange,
  selectedProduct,
  onConfirm,
}: ReturnDialogProps) => {
  const [quantity, setQuantity] = useState("");
  const [refundAmount, setRefundAmount] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [condition, setCondition] = useState("");

  const handleSubmit = () => {
    if (!quantity || parseInt(quantity) <= 0) {
      toast.error("Veuillez entrer une quantité valide");
      return;
    }

    if (!refundAmount || parseFloat(refundAmount) <= 0) {
      toast.error("Veuillez entrer un montant de remboursement valide");
      return;
    }

    if (!paymentMethod) {
      toast.error("Veuillez sélectionner une méthode de paiement");
      return;
    }

    if (!condition) {
      toast.error("Veuillez indiquer l'état du produit retourné");
      return;
    }

    onConfirm(
      parseInt(quantity),
      parseFloat(refundAmount),
      paymentMethod,
      condition
    );
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Retour de produit</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="quantity">Quantité à retourner</Label>
            <Input
              id="quantity"
              type="number"
              value={quantity}
              onChange={(e) => setQuantity(e.target.value)}
              min="1"
              max={selectedProduct?.quantity}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="refundAmount">Montant du remboursement</Label>
            <Input
              id="refundAmount"
              type="number"
              value={refundAmount}
              onChange={(e) => setRefundAmount(e.target.value)}
              min="0"
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="paymentMethod">Méthode de remboursement</Label>
            <Select value={paymentMethod} onValueChange={setPaymentMethod}>
              <SelectTrigger>
                <SelectValue placeholder="Sélectionnez une méthode" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="cash">Espèces</SelectItem>
                <SelectItem value="mobile_money">Mobile Money</SelectItem>
                <SelectItem value="bank_transfer">Virement bancaire</SelectItem>
              </SelectContent>
            </Select>
          </div>
          <div className="grid gap-2">
            <Label htmlFor="condition">État du produit</Label>
            <Select value={condition} onValueChange={setCondition}>
              <SelectTrigger>
                <SelectValue placeholder="Sélectionnez l'état" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="good">Bon état</SelectItem>
                <SelectItem value="damaged">Endommagé</SelectItem>
                <SelectItem value="defective">Défectueux</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button onClick={handleSubmit}>Confirmer</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};